import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { viewProgramCost } from '../utils/viewProgramCost';

import styles from './styles.styl';

const ProgramSubscription = ({
  formatMessage,
  handleChangeMembershipDuration,
  isSubscriptionStatusPending,
  prepaidByProvider,
  program,
  selectedMembershipId,
  subscriptionsSetting,
}) => {
  const { withSubscription, subscriptionsSettings = [] } = {
    ...program,
  };

  const onlyOneSubscriptionOption =
    subscriptionsSettings.length === 1 || prepaidByProvider;

  const moreThanOneSubscriptionOption = subscriptionsSettings.length > 1;

  const {
    price,
    period,
    periodQuantity,
    recurrenceType,
    description: subscriptionSettingsDescription = '',
  } = { ...subscriptionsSetting };

  const programCostTitle = useMemo(
    () => (
      <div className={styles.programCost}>
        {formatMessage({ id: 'program.invite.programCost' })}
      </div>
    ),
    [],
  );

  return (
    <Choose>
      <When condition={Boolean(withSubscription)}>
        <If condition={onlyOneSubscriptionOption}>
          <div className={styles.section}>
            <div className={styles.wrapper}>
              {programCostTitle}
              <div className={styles.costValue}>
                {`${viewProgramCost({
                  price,
                  period,
                  formatMessage,
                  recurrenceType,
                  quantity: periodQuantity,
                })} ${
                  prepaidByProvider
                    ? formatMessage({ id: 'program.membership.prepaid' })
                    : ''
                }`}
                <span className={styles.costDescription}>
                  {subscriptionSettingsDescription}
                </span>
              </div>
            </div>
          </div>
        </If>

        <If
          condition={
            moreThanOneSubscriptionOption && isSubscriptionStatusPending
          }
        >
          <div className={styles.section}>
            {programCostTitle}
            <div className={styles.radioButtonWrapper}>
              {subscriptionsSettings.map(subscription => {
                return (
                  <div key={subscription.id} className={styles.radioItem}>
                    <input
                      type="radio"
                      id={subscription.id}
                      name={`membershipDuration_${program.id}`}
                      value={subscription.id}
                      checked={selectedMembershipId === subscription.id}
                      onChange={() =>
                        handleChangeMembershipDuration(subscription.id)
                      }
                    />
                    <label
                      htmlFor={subscription.id}
                      className={styles.radioItemLabel}
                    >
                      <span className={styles.costValue}>{`${viewProgramCost({
                        price: subscription.price,
                        period: subscription.period,
                        formatMessage,
                        recurrenceType: subscription.recurrenceType,
                        quantity: subscription.periodQuantity,
                      })}`}</span>
                      <span>{subscription.description || ''}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </If>
      </When>
    </Choose>
  );
};

ProgramSubscription.propTypes = {
  formatMessage: PropTypes.func,
  handleChangeMembershipDuration: PropTypes.func,
  isSubscriptionStatusPending: PropTypes.bool,
  prepaidByProvider: PropTypes.bool,
  program: PropTypes.object,
  selectedMembershipId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  subscriptionsSetting: PropTypes.object,
};

export default ProgramSubscription;



// WEBPACK FOOTER //
// ./src/components/Programs/ProgramSubscription/index.jsx